import Select, { SelectProps } from "@/shared/form/select";
import { PersonOption } from "../option/option";
import { usePersonOptions } from "../../model/usePersonOptions";
import { useTranslations } from "use-intl";
import Button from "@/shared/form/button";
import { FullscreenOutlined } from "@ant-design/icons";
import { Space } from "@/shared/layout/space";
import { Modal, useModal } from "@/shared/modal";
import { PersonSelectExtended } from "../../../person-select-extended";
import { twMerge } from "tailwind-merge";

type PersonSelectProps = Omit<SelectProps, "onChange"> & {
  onChange?: (values: undefined | string | string[]) => void;
};

export function PersonSelect({
  onChange,
  value,
  mode,
  disabled,
  size,
  className,
  ...props
}: PersonSelectProps) {
  const { loading, options, persons } = usePersonOptions();
  const t = useTranslations("PersonSelect");

  const { close, open, openModal } = useModal();

  return (
    <>
      <Space.Compact block>
        <Select
          className={twMerge("!w-full", className)}
          showSearch
          placeholder={t("Select a person")}
          loading={loading}
          disabled={disabled}
          filterOption={(input, option) =>
            (option?.label ?? "")
              .toString()
              .toLowerCase()
              .includes(input.toLowerCase())
          }
          options={options}
          optionRender={(option) => (
            <PersonOption
              name={option.label as string}
              avatar={
                (persons ?? []).find((p) => p.id === option.value)?.avatar
              }
            />
          )}
          onChange={onChange}
          value={value}
          mode={mode}
          size={size}
          popupMatchSelectWidth={false}
          {...props}
        />
        <Button
          icon={<FullscreenOutlined />}
          onClick={open}
          disabled={disabled}
          size={size}
        />
      </Space.Compact>
      <Modal
        title={t("Select persons")}
        open={openModal}
        onCancel={close}
        width={900}
      >
        <PersonSelectExtended
          close={close}
          onChange={onChange}
          value={value}
          mode={mode}
        />
      </Modal>
    </>
  );
}
